'use client'

import dynamic from 'next/dynamic'

const CustomScript = dynamic(() => {
    return import("../CustomScript")
}, { 
    ssr: false
})

export default function CustomScriptClient({ customVersion }) {
    return <CustomScript customVersion={customVersion} />
}

